/*
 * Created on Thu Oct 12 2023 10:27:53 AM
 *
 * ***************************************************************************************
 * Copyright (c) AVPS Technologies Inc 2023 
 *
 * All Rights Reserved
 * Unpublished rights are reserved under the copyright laws of the United States.
 * The software contained in this media is proprietary to and embodies confidential
 * the technology of AVPS Technologies Inc. Possession, use, duplication or
 * dissemination of the software and media is authorized only pursuant to a valid
 * written license from AVPS Technologies Inc.
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * RESTRICTED RIGHTS LEGEND Use, duplication, or disclosure by the U.S. Government
 * is subject to restrictions as set forth in Subparagraph (c) (1) (ii) of DFARS
 * 252.227-7013 or in FAR 52.227-19, as applicable.
 ****************************************************************************************
 */
const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
